export const ORDER_STATUS_CODES = {
  NEW: 'new',
  ACCEPTED: 'accepted',
  IN_PROGRESS: 'inprogress',
  COMPLETED: 'completed',
  CLAIM: 'claim',
  CANCELLED: 'cancelled',
  WASTED_VISIT: 'wastedvisit',
};
